export const AppVersion: string = 'v1.36.2';
